import React from 'react';
import { Route } from 'react-router';

import ApplicationTemplates from 'components/landlord_app/application_templates/ApplicationTemplates';
import CreateApplicationTemplate from 'components/landlord_app/application_templates/CreateApplicationTemplate';
import ApplicationTemplateWizardContainer from 'components/landlord_app/application_templates/ApplicationTemplateWizardContainer';
import EditApplicationTemplate from 'components/landlord_app/application_templates/EditApplicationTemplate';
import CreateStep from 'components/landlord_app/application_templates/CreateStep';
import EditStep from 'components/landlord_app/application_templates/EditStep';
import CreateOrUpdatePackage from 'components/landlord_app/application_templates/Packages/CreateOrUpdatePackage';

const ApplicationTemplatesBuilderRoutes = (authenticateLandlord) => {
  return (
    <React.Fragment>
      <Route
        path="application_templates"
        component={ApplicationTemplates}
        onEnter={authenticateLandlord}
      />
      <Route
        path="application_templates/new"
        component={CreateApplicationTemplate}
        onEnter={authenticateLandlord}
      />
      <Route
        path="application_templates/:applicationTemplateId/edit"
        component={EditApplicationTemplate}
        onEnter={authenticateLandlord}
      />
      <Route
        path="application_templates/:applicationTemplateId/steps/new"
        component={CreateStep}
        onEnter={authenticateLandlord}
      />
      <Route
        path="application_templates/:applicationTemplateId/steps/:stepId/edit"
        component={EditStep}
        onEnter={authenticateLandlord}
      />
      <Route
        path="application_templates/:applicationTemplateId/wizard/:mode"
        component={ApplicationTemplateWizardContainer}
        onEnter={authenticateLandlord}
      />
      <Route
        path="application_packages/new"
        component={CreateOrUpdatePackage}
        onEnter={authenticateLandlord}
      />
      <Route
        path="application_packages/:applicationPackageId/edit"
        component={CreateOrUpdatePackage}
        onEnter={authenticateLandlord}
      />
    </React.Fragment>
  );
};

export default ApplicationTemplatesBuilderRoutes;
